
import RecordDetail from './com/record-detail.vue'
import { Component } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import { SIGN_STATUS_LIST, canCheck, canClose, getSignStatusText, getSignStatusClass } from '@/common/sign'

@Component({
  components: { RecordDetail }
})
export default class extends ListViewVue {
  listType = "router";

  /** 下拉的 value 统一成字符串，见模板里的说明 */
  statusList = SIGN_STATUS_LIST.map((item) => {
    return { name: item.name, value: `${item.value}` };
  });

  activityName = "";
  /** 活动的表头定义，详情弹窗要把答案的 key（表头 id）翻成名称 */
  rowList: any[] = [];

  getSignStatusText = getSignStatusText;
  getSignStatusClass = getSignStatusClass;
  canCheck = canCheck;
  canClose = canClose;

  /** 活动 id 走路由 query，列表内容按它查 */
  get activityId() {
    return this.$route.query.id;
  }

  getCondition() {
    return { status: "" }
  }

  async created() {
    if (!this.activityId) {
      return this.$error("缺少活动ID");
    }
    let { error, data } = await this.$post("/manager/sign/detail", {
      id: this.activityId,
    });
    if (error) return;
    this.activityName = data.name || "";
    this.rowList = data.activityRowList || [];
  }

  async getList() {
    /** id 显式带上：condition_ 里虽然也有（来自 query），但不该依赖它的更新时机 */
    let data: any = { ...this.mesureData, id: this.activityId };
    /** 空状态不传：后端 status 是 @IsEnum，空串会被打回 400 */
    if (data.status === '' || data.status == null) {
      delete data.status;
    } else {
      data.status = Number(data.status);
    }
    return this.$post("/manager/sign/sign-list", data);
  }

  resetFilter() {
    this.find(this.getCondition());
  }

  detail(row) {
    /** 取消时 $dialog 是 reject，不接住就是一个未处理的 rejection */
    this.$dialog({
      title: "报名详情",
      props: { width: "700px" },
      content: () => <RecordDetail modelValue={row} rows={this.rowList} />,
    }, 'sign-record').catch(() => { });
  }

  /**
   * 审核：isPass 1 通过、0 驳回。驳回的原因后端存 checkRemark，
   * $inputContent 取消时是 reject，得 try 住，不然会当成「没填备注」继续提交
   */
  async check(row, isPass) {
    let payload: any = { id: row.id, isPass };
    if (isPass != 1) {
      let remark;
      try {
        remark = await this.$inputContent({
          title: "驳回原因",
          value: "",
          maxlength: 200,
          placeholder: "可填写驳回原因，200 字以内",
        });
      } catch (e) {
        return;
      }
      if (remark) payload.checkRemark = remark;
    }
    await this.operate("/manager/sign/sign-check", payload);
  }

  async close(row) {
    await this.operate("/manager/sign/sign-close", { id: row.id });
  }

  /**
   * 这几个操作都不在 ValidateDec 底下，$postNotify / $postError 出错时会往外抛，
   * 在弹窗和表格的点击回调里就是未处理的 rejection，所以统一用 $post 自己弹
   */
  async operate(url, payload) {
    let { error, message } = await this.$post(url, payload);
    if (error) return this.$error(message);
    this.$success("操作成功");
    this.refresh();
  }
}
